import { getCtaRef } from "../analytics/common";
import getWindow from "./window";
import { track } from "./features";

export const trackCtaRefInOptimizely = () => {
  let ctaRef = getCtaRef();

  if (ctaRef) {
    ctaRef = ctaRef && ctaRef.split("_")[0].toLowerCase();

    const matchedTracker = getWindow().asos.pdp.config.featuresCtaTracking.find(
      (feature) => feature.matchCta.toLowerCase() === ctaRef
    )?.trackingKey;

    if (matchedTracker) {
      track(matchedTracker);
    }
  }
};
